import Typography from '@setproduct-ui/core/Typography';
import React, { ComponentProps } from 'react';

export const H5 = ({ children, ...rest }: ComponentProps<typeof Typography>) => (
  <Typography type="h5" tagName="h5" color="default" colorStep={90} {...rest}>
    {children}
  </Typography>
);
